// Copyright 2019 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
import React from 'react';

import InfoHint from './info-hint';

const EnterpriseNotification = ({ isEnterprise, benefit }) =>
  !isEnterprise && (
    <InfoHint
      content={
        <span>
          {`With a more advanced commercial Mender plan you get access to ${benefit}. Get an overview of the Mender plans on the `}
          <a href="https://mender.io/plans/features" target="_blank" rel="noopener noreferrer">
            features page
          </a>
          .
        </span>
      }
    />
  );

export default EnterpriseNotification;
